var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumnManager(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1750821767750,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 4249,
    width: 22,
    height: 22,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.2 64H70.4C32 64 0 96 0 140.8v268.8c0 38.4 32 70.4 70.4 70.4h268.8c44.8 0 76.8-32 76.8-76.8V140.8C416 96 384 64 339.2 64z m-64 275.2H140.8V204.8h140.8v134.4zM339.2 550.4H76.8C32 550.4 0 582.4 0 620.8v262.4c0 44.8 32 76.8 76.8 76.8h262.4c38.4 0 76.8-32 76.8-76.8V620.8c0-38.4-38.4-70.4-76.8-70.4z m-64 275.2H140.8v-134.4h140.8v134.4zM576 192h384c38.4 0 64-25.6 64-64s-25.6-64-64-64H576c-38.4 0-64 32-64 64 0 38.4 25.6 64 64 64zM960 448H576c-38.4 0-64 32-64 64 0 38.4 25.6 64 64 64h384c38.4 0 64-25.6 64-64 0-32-25.6-64-64-64zM960 832H576c-38.4 0-64 25.6-64 64s25.6 64 64 64h384c38.4 0 64-25.6 64-64 0-32-25.6-64-64-64z",
    fill: "#2c2c2c",
    "p-id": 4250
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnManager);
export default __webpack_public_path__ + "static/media/ColumnManager.a641a0d8972562c6684221db16c54d1a.svg";
export { ForwardRef as ReactComponent };